/**
 * Header search bar. Clicking it, or typing into it, opens the predictive search modal
 * and carries over any text already typed. Without the modal it submits like a normal search form.
 */
class HeaderSearchBar extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');
    if (!this.input) return;

    this.input.addEventListener('click', this.#openModal);
    this.input.addEventListener('input', this.#openModal);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('click', this.#openModal);
    this.input?.removeEventListener('input', this.#openModal);
  }

  #openModal = () => {
    const modal = /** @type {any} */ (document.getElementById('search-modal'));
    if (!modal || typeof modal.showDialog !== 'function') return;

    const text = this.input.value;
    this.input.value = '';
    this.input.blur();
    modal.showDialog();

    // showDialog opens the dialog on the next animation frame
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const modalInput = modal.querySelector('input[name="q"]');
        if (!modalInput) return;

        modalInput.focus();
        if (text) {
          modalInput.value = text;
          modalInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  };
}

if (!customElements.get('header-search-bar')) {
  customElements.define('header-search-bar', HeaderSearchBar);
}
